class DDVariantPicker extends HTMLElement {
  constructor() {
    super();

    this.selectedVariants = [];
  }

  connectedCallback() {
    this.addEventListener(
      'change',
      this.handleVariantChange.bind(this)
    );

    this.addEventListener(
      'change',
      this.handleQuantityChange.bind(this)
    );
      // Click the first product gallery thumbnail on page load
      requestAnimationFrame(() => {
        const firstThumbnail = document.querySelector(
          '.product-gallery__thumbnail'
        );

        if (firstThumbnail) {
          firstThumbnail.click();
        }
      });
  }

  handleVariantChange(event) {
    const checkbox = event.target;

    if (
      checkbox.type !== 'checkbox' ||
      !checkbox.matches('input[data-option-position]')
    ) {
      return;
    }

    const variantId = checkbox.dataset.variantCustomId;

    if (!variantId) return;

    const quantityInput = this.querySelector(
      `input.quantity-selector__input[data-variant-custom-id="${variantId}"]`
    );

    const qty = quantityInput
      ? Number(quantityInput.value) || 1
      : 1;

    if (checkbox.checked) {
      const existing = this.selectedVariants.find(
        item => String(item.id) === String(variantId)
      );

      if (existing) {
        existing.qty = qty;
      } else {
        this.selectedVariants.push({
          id: variantId,
          qty: qty
        });
      }
    } else {
      this.selectedVariants = this.selectedVariants.filter(
        item => String(item.id) !== String(variantId)
      );
    }

    this.updateSelectedVariants();
  }

  handleQuantityChange(event) {
    const quantityInput = event.target;

    if (
      !quantityInput.matches(
        'input.quantity-selector__input[data-variant-custom-id]'
      )
    ) {
      return;
    }

    const variantId =
      quantityInput.dataset.variantCustomId;

    const qty =
      Number(quantityInput.value) || 1;

    const existing = this.selectedVariants.find(
      item => String(item.id) === String(variantId)
    );

    /*
     * Only update the quantity of THIS variant.
     */
    if (existing) {
      existing.qty = qty;

      this.updateSelectedVariants();
    }
  }

  updateSelectedVariants() {
    this.dataset.selectedVariants = JSON.stringify(
      this.selectedVariants
    );

    console.log(
      'selectedVariants:',
      this.selectedVariants
    );
  }

  getSelectedVariants() {
    return this.selectedVariants;
  }
}

if (!window.customElements.get('dd-variant-picker')) {
  window.customElements.define(
    'dd-variant-picker',
    DDVariantPicker
  );
}